import { flexRowCenterCenter } from '../../../../common/styles/flex';

interface StylesObject {
  skipVideoIconStyle: { [key: string]: any };
  skipIconClickableWrapperStyle: { [key: string]: any };
  iconAndToolTipContainerStyle: { [key: string]: any };
  skipIconWrapperStyle: { [key: string]: any };
}

const skipVideoIcon = {
  cursor: 'pointer',
  opacity: '0.7',
  margin: '0px 8px',
  disable: {
    cursor: 'auto',
    opacity: '0.3',
  },
  hover: {
    opacity: '1',
  },
  hide: {
    display: 'none',
  },
};

const skipIconClickableWrapper = {
  ...flexRowCenterCenter,
  height: '40px',
  width: '40px',
};

const skipIconWrapper = {
  position: 'relative',
  display: 'grid',
  order: '1',
};

const iconAndToolTipContainer = {
  position: 'relative',
  display: 'grid',
};

export const getSkipVideoButtonStyleObject = (disableIcon: boolean, hovered: boolean, showAdControls: boolean, desktopMode: boolean, showSkipVideoTooltip: boolean, isRecirculationControls: boolean): StylesObject => ({
  skipVideoIconStyle: [
    skipVideoIcon,
    isRecirculationControls && skipVideoIcon.hover,
    desktopMode && hovered && skipVideoIcon.hover,
    disableIcon && skipVideoIcon.disable,
    showAdControls && skipVideoIcon.hide,
  ],
  skipIconClickableWrapperStyle: {
    ...skipIconClickableWrapper,
  },
  iconAndToolTipContainerStyle: {
    ...iconAndToolTipContainer,
  },
  skipIconWrapperStyle: [
    !showSkipVideoTooltip && skipIconWrapper,
  ],
});
